import type { TrackingEventProperties } from '@change-corgi/core/eventTracker';

/**
 * Every property key set by page-level tracking providers that wrap `LoginModal`:
 * Nested `TrackingContext` merges `{ ...this.properties, ...eventPayload }` before calling the parent;
 * the parent then merges promote/membership props on top. Setting these to `undefined` here lets the
 * inner payload override those keys so they are cleared on the final merged object (for keys present
 * in both layers).
 */
export const loginModalTrackingPropertyReset = {
	amount: undefined,
	bonus_cpm: undefined,
	bonus_impressions: undefined,
	content: undefined,
	context: undefined,
	cpm: undefined,
	currency: undefined,
	custom_amount: undefined,
	exchange_rate: undefined,
	impression_count: undefined,
	impressions_to_fulfill: undefined,
	is_public: undefined,
	local_amount: undefined,
	own_petition: undefined,
	payment_term: undefined,
	payment_type: undefined,
	petition_id: undefined,
	price: undefined,
	product_flow: undefined,
	promote_transaction: undefined,
	promoted_bandit_variant_shown: undefined,
	public: undefined,
	quantity: undefined,
	revenue_type: undefined,
	save_payment_method: undefined,
	source_location: undefined,
	subscriber: undefined,
	subscription_program_country_slug: undefined,
	subscription_program_id: undefined,
	subscription_program_name: undefined,
	subscription_program_type: undefined,
	transaction_upsell_opt_in: undefined,
	use_saved_payment_method: undefined,
	visible_payment_types: undefined,
} as const satisfies TrackingEventProperties;
